import { Users, Pagination } from '@factorin/domain';

import { withUrl, get, post, put, remove, Request, ItemRequest, patch } from '../rest';


type CreateBodyRequest = Pick<Users.CompanyUserDetails, 'Login' | 'FirstName' | 'MiddleName' | 'Surname' | 'INN' | 'PhoneNumber' | 'IsWarrantIssuer' | 'IsWarrantRevoker' | 'NotificationEmail' | 'Permissions' | 'NotificationEvents'> & {
    Password: string;
};

type UpdateBodyRequest = Pick<Users.CompanyUserDetails, 'FirstName' | 'MiddleName' | 'Surname' | 'INN' | 'PhoneNumber' | 'IsWarrantIssuer' | 'IsWarrantRevoker' | 'NotificationEmail' | 'Permissions' | 'NotificationEvents'> & {
    ClientProfileUid: string;
}

interface ChangePasswordRequest {
    NewPassword: string;
}

type RequestFilters = Partial<{
    login: string;
    surname: string;
    firstname: string;
    middlename: string;
    isEIO: boolean;
}>;

const companyAdminPart = withUrl('users');

export const companyUsers = {
    list: get<
    Request.Query<Pagination.Request & RequestFilters>,
    Pagination.List<Users.CompanyUser>
    >(
        ({ query: { isEIO, ...query } }) => companyAdminPart({
            path: isEIO ? 'availablewarrantissuers' : '',
            query,
        }),
    ),
    item: get<ItemRequest, Users.CompanyUserDetails>(
        ({ id }) => companyAdminPart({
            path: `${id}`,
        }),
    ),
    create: post<Request.Body<CreateBodyRequest>, Users.CompanyUser>(
        ({ body }) => companyAdminPart({
            body,
        }),
    ),
    update: put<ItemRequest & Request.Body<UpdateBodyRequest>, Users.CompanyUser>(
        ({ id, body }) => companyAdminPart({
            path: `${id}`,
            body,
        }),
    ),
    remove: remove<ItemRequest, void>(
        ({ id }) => companyAdminPart({
            path: `${id}`,
        }),
    ),
    changePassword: patch<ItemRequest & Request.Body<ChangePasswordRequest>, void>(
        ({ id, body }) => companyAdminPart({
            path: `${id}/password`,
            body,
        }),
    ),
};
